export default __webpack_public_path__ + "static/media/raspira.841b52ef.svg";